/* eslint-disable no-unused-vars */
import { Button, Col, Input, Row, Select, message } from "antd";
import React, { useEffect, useState } from "react";
import "../../styles/compareWizard.css";
import StepFooter from "./StepFooter";
import FieldMappingTable from "../table/FieldMappingTable";
import { getMapping, getMappingNames } from "../../service/db.service";
import {
  checkElementArrayObjArray,
  simpleArrayToTree,
} from "../../helper/array_helper";
import NewMappingTable from "../table/NewMappingTable";

const { Option } = Select;
function MapFields(props) {
  const [newMapping, setNewMapping] = useState("");
  const [listOfMapping, setListOfMapping] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [mappingName, setMappingName] = useState("");
  const [existingMappingData, setExistingMappingData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [fieldLevelData, setFieldLevelData] = useState([]);
  const [mappingNameDisabled, setMappingNameDisabled] = useState(false);
  const [existingMappingName, setExistingMappingName] = useState("");
  const [isTableSaved, setIsTableSaved] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [mappingMismatch, setMappingMismatch] = useState(false);

  const onClickPrevious = () => {
    props.clickPrevious(2);
  };
  const onConfirmConditions = (tableData, isPresent, fieldTests, type) => {
    if (tableData.length > 0) {
      if (!isPresent) {
        message.error(
          "Select at least one Unique Identifier between the two sources"
        );
      } else {
        props.confirmMapFields(4, tableData, mappingName, fieldTests, type);
      }
    } else {
      message.error("Select atleast one mapping!");
    }
  };
  const onClickConfirmMap = () => {
    if (mappingName.length > 0) {
      if (isTableSaved) {
        if (newMapping === "new") {
          const isPresent = dataSource.some((d) => d.rowKey === true);
          onConfirmConditions(dataSource, isPresent, fieldLevelData, "new");
        } else {
          if (mappingNameDisabled) {
            /*When existing mapping is selected */
            let selectedColumns = existingMappingData.map(
              (item) => item["source1"] + "-" + item["rowKey"]
            );
            let existingHeaders = simpleArrayToTree(selectedColumns);
            const isPresent = existingMappingData.some(
              (d) => d.rowKey === true
            );
            onConfirmConditions(
              existingMappingData,
              isPresent,
              existingHeaders,
              "existing"
            );
          } else {
            if (
              JSON.stringify(existingMappingData) === JSON.stringify(dataSource)
            ) {
              /** When user clicks save and mapping is not changed */
              let selectedColumns = existingMappingData.map(
                (item) => item["source1"] + "-" + item["rowKey"]
              );
              let existingHeaders = simpleArrayToTree(selectedColumns);
              const isPresent = existingMappingData.some(
                (d) => d.rowKey === true
              );
              onConfirmConditions(
                existingMappingData,
                isPresent,
                existingHeaders,
                "existing"
              );
            } else {
              /** When user edits the mapping */
              if (mappingName.trim() !== existingMappingName.trim()) {
                const isPresent = dataSource.some((d) => d.rowKey === true);
                const updatedData = dataSource.map((item) => {
                  return { ...item, mappingName: mappingName };
                });
                onConfirmConditions(
                  updatedData,
                  isPresent,
                  fieldLevelData,
                  "new"
                );
              } else {
                message.error("Save with a new mapping name!");
              }
            }
          }
        }
      } else {
        message.error("Please save before clicking next!");
      }
    } else {
      message.error("Mapping name is mandatory");
    }
  };
  const handleMappingTypeSelection = (value) => {
    setExistingMappingData([]);
    setMappingName("");
    setNewMapping(value);
    if (value === "existing") {
      setMappingNameDisabled(true);
      getMappingAsList();
      setIsTableSaved(true);
    } else {
      setMappingMismatch(false);
      setMappingNameDisabled(false);
      setExistingMappingName("");
      setMappingName("");
    }
  };
  const handleMappingNameSelection = (value) => {
    setExistingMappingName(value);
    setMappingName(value);
    getMappingByName(value);
  };
  const assignDataSource = (data, selectedHeaders, isSaved) => {
    const containsFile = checkElementArrayObjArray(
      data,
      props.fileHeader,
      "source1"
    );
    const containsSql = checkElementArrayObjArray(
      data,
      props.sqlHeader,
      "source2"
    );
    if (containsFile && containsSql) {
      setMappingMismatch(false);
    } else {
      message.error("The selected mapping does not match with File or SQL");
      setMappingMismatch(true);
    }
    setFieldLevelData(simpleArrayToTree(selectedHeaders));
    setDataSource(data);
    setIsTableSaved(isSaved);
  };
  const editMappingName = () => {
    setMappingNameDisabled(false);
  };
  const getMappingByName = (mappingName) => {
    setExistingMappingData([]);

    getMapping(mappingName).then((res) => {
      setTableLoading(true);
      try {
        const containsFile = checkElementArrayObjArray(
          res.data,
          props.fileHeader,
          "source1"
        );
        const containsSql = checkElementArrayObjArray(
          res.data,
          props.sqlHeader,
          "source2"
        );
        if (!containsFile) {
          setMappingMismatch(true);
          message.error("The selected mapping does not match with File");
        } else if (!containsSql) {
          setMappingMismatch(true);
          message.error("The selected mapping does not match with SQL");
        } else {
          setMappingMismatch(false);
        }
        setExistingMappingData(res.data);
      } catch (err) {
        console.log(err);
      } finally {
        setTableLoading(false);
      }
    });
  };
  const getMappingAsList = () => {
    getMappingNames().then((res) => {
      setListOfMapping(res.data);
    });
  };

  // Optional: when launched from the Mapping Library, preselect that mapping as
  // an existing mapping on mount. Backward-compatible — callers that don't pass
  // initialMappingName are unaffected.
  useEffect(() => {
    if (props.initialMappingName) {
      handleMappingTypeSelection("existing");
      handleMappingNameSelection(props.initialMappingName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="cmp-pane">
      <div className="cmp-field">
        <span className="cmp-field-label">
          Make a selection<span className="req">*</span>
        </span>
        <Select
          placeholder="make a selection"
          style={{ width: "100%" }}
          onChange={handleMappingTypeSelection}
          name="selection dropdown"
        >
          <Option value="existing">From existing mapping</Option>
          <Option value="new">Create new mapping</Option>
        </Select>
      </div>
      {(() => {
        switch (newMapping) {
          case "existing":
            return (
              <div className="cmp-field">
                <span className="cmp-field-label">
                  Select mapping<span className="req">*</span>
                </span>
                <Select
                  showSearch
                  placeholder="select from existing"
                  optionFilterProp="value"
                  filterOption={(input, option) =>
                    option?.value.toLowerCase().includes(input.toLowerCase())
                  }
                  style={{ width: "100%" }}
                  onChange={handleMappingNameSelection}
                >
                  {listOfMapping.map((data) => (
                    <Option key={data} value={data}>
                      {data}
                    </Option>
                  ))}
                </Select>
              </div>
            );
          case "new":
            return <span />;
          default:
            break;
        }
      })()}
      <div className="cmp-field">
        <span className="cmp-field-label">
          Mapping name<span className="req">*</span>
        </span>
        <Input
          placeholder="name"
          value={mappingName}
          disabled={mappingNameDisabled}
          onChange={(e) => {
            setMappingName(e.target.value);
          }}
        />
      </div>
      {(() => {
        switch (newMapping) {
          case "existing":
            return (
              <div>
                <Row>
                  <Col span={24}>
                    <NewMappingTable
                      initialData={existingMappingData}
                      sqlHeader={props.sqlHeader}
                      fileHeader={props.fileHeader}
                      mappingName={mappingName}
                      assignDataSource={assignDataSource}
                      editMappingName={editMappingName}
                      tableLoading={tableLoading}
                      dataSourceOne={props.dataSourceOneColumn}
                      dataSourceTwo={props.dataSourceTwoColumn}
                    />
                  </Col>
                </Row>
              </div>
            );
          case "new":
            return (
              <div>
                <Row>
                  <Col span={24}>
                    <FieldMappingTable
                      fileHeader={props.fileHeader}
                      sqlHeader={props.sqlHeader}
                      mappingName={mappingName}
                      assignDataSource={assignDataSource}
                      initialData={initialData}
                      dataSourceOne={props.dataSourceOneColumn}
                      dataSourceTwo={props.dataSourceTwoColumn}
                    />
                  </Col>
                </Row>
              </div>
            );
          default:
            return <p></p>;
        }
      })()}

      <StepFooter
        showBack
        onBack={onClickPrevious}
        onNext={onClickConfirmMap}
        nextDisabled={mappingMismatch}
      />
    </div>
  );
}

export default MapFields;
